import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-naac-committee',
  templateUrl: './naac-committee.component.html',
  styleUrls: ['./naac-committee.component.scss']
})
export class NaacCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
